"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StarIcon = function StarIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M7.998.2l1.885 5.816h6.094l-4.93 3.586 1.894 5.813-4.943-3.597-4.944 3.597 1.893-5.813-4.97-3.586h6.135z"
    }) : _react["default"].createElement("path", {
      d: "M15.977 6.016H9.883L7.998.2 6.112 6.016H-.023l4.97 3.586-1.893 5.813 4.944-3.597 4.943 3.597-1.894-5.813zm-7.979 4.566l-3.038 2.21 1.164-3.573-3.052-2.203h3.767l1.159-3.573 1.158 3.573h3.746l-3.03 2.206 1.162 3.569z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M12.003.3l2.827 8.725h9.14l-7.394 5.378 2.842 8.72-7.415-5.396-7.417 5.395 2.84-8.719-7.455-5.378h9.203z"
    }) : _react["default"].createElement("path", {
      d: "M23.97 9.025h-9.14L12.003.3 9.174 9.025H-.029l7.456 5.378-2.84 8.72 7.416-5.396 7.415 5.395-2.842-8.719zm-6.46 11.473l-5.507-4.007-5.51 4.008 2.11-6.48-5.537-3.995H9.9l2.101-6.481 2.101 6.481h6.793L15.4 14.022z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M16.008.4l3.77 11.633h12.187l-9.86 7.172 3.79 11.625-9.887-7.194-9.889 7.194 3.787-11.625-9.941-7.172h12.271z"
  }) : _react["default"].createElement("path", {
    d: "M31.965 12.033H19.778L16.008.4l-3.772 11.633H-.035l9.941 7.172L6.12 30.83l9.889-7.194 9.886 7.194-3.788-11.625zm-7.978 16.173l-7.98-5.806-7.982 5.807 3.058-9.386-8.023-5.788h9.903l3.044-9.39 3.043 9.39h9.84l-7.96 5.791z"
  }));
};

var _default = StarIcon;
exports["default"] = _default;